import { Injectable } from '@angular/core';
import { Observable, map, combineLatest } from 'rxjs';
import { ThemeService } from '../../../core/services/theme.service';
import { AssetUpdaterService } from '../../../core/services/asset-updater.service';

@Injectable({
    providedIn: 'root'
})
export class UserAvatarService {

    constructor(
        private themeService: ThemeService,
        private assetUpdaterService: AssetUpdaterService
    ) { }

    /**
     * Obtiene la URL del avatar personalizado del tema activo
     * @returns Observable con la URL del avatar o null si no hay personalización
     */
    getCustomUserAvatarUrl(): Observable<string | null> {
        return combineLatest([
            this.assetUpdaterService.userAvatarUrl$,
            this.themeService.currentTheme$
        ]).pipe(
            map(([flatAvatarUrl, legacyTheme]) => {
                // Prioridad: Sistema plano → Sistema legacy
                if (flatAvatarUrl) {
                    return flatAvatarUrl;
                }

                return legacyTheme?.colors?.userAvatarUrl || null;
            })
        );
    }

    /**
     * Obtiene la URL del avatar que se debe usar, considerando personalización y fallbacks
     * @param userImage URL de imagen del usuario (si la tiene)
     * @param defaultImage URL de imagen por defecto
     * @returns Observable con la URL final del avatar
     */
    getFinalAvatarUrl(userImage?: string, defaultImage: string = '../../assets/icons/navbar/nav-user-icon.svg'): Observable<string> {
        return this.getCustomUserAvatarUrl().pipe(
            map(customAvatarUrl => {
                // Si hay avatar personalizado del tema, usarlo
                if (customAvatarUrl) {
                    return customAvatarUrl;
                }

                // Si el usuario tiene una imagen propia (no placeholder), usarla
                if (userImage && userImage !== defaultImage) {
                    return userImage;
                }

                // Usar imagen por defecto
                return defaultImage;
            })
        );
    }
}
